import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import { getButtonLinkProps, ROUTES } from '@openclassrooms/routing';
import { usePermissions, useCurrentUserContext } from '@openclassrooms/data-connect-web/users';
function usePromotionType() {
  const $ = _c(3);
  const {
    userId
  } = useCurrentUserContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = Boolean(userId);
  let t2;
  if ($[1] !== t1) {
    t2 = {
      retry: 0,
      enabled: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    can
  } = usePermissions(t0, t2);
  const canAccessJobPostings = can("ACCESS_JOB_POSTINGS");
  if (canAccessJobPostings) {
    return "jobMarketplace";
  }
}
function usePromotionProps() {
  const $ = _c(3);
  const promotionType = usePromotionType();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = translate("profile_menu.job_marketplace.banner.description");
    t1 = translate("global.word.access_job_marketplace");
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      jobMarketplace: {
        description: t0,
        ctaLabel: t1,
        ctaProps: {
          "data-event": "Navigation|Redirection::Internal|Callout menu drawer find apprenticeship",
          ...getButtonLinkProps(ROUTES.SPACES.STUDENT.JOB_POSTINGS)
        }
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const promotionProps = t2 as const;
  if (!promotionType) {
    return;
  }
  return promotionProps[promotionType];
}
export default usePromotionProps;